import { render, staticRenderFns } from "./ColumnConfigDialog.vue?vue&type=template&id=413f2527&scoped=true"
import script from "./ColumnConfigDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ColumnConfigDialog.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f2527",
  null
  
)

export default component.exports